<template>
    <div class="doc-footer">
        <Row>
            <Col>
                <Row><h3>相关资源</h3></Row>
                <Row><a href="https://github.com/" target="_blank">Github</a></Row>
            </Col>
            <Col>
                <Row><h3>帮助</h3></Row>
                <Row><a href="https://github.com/" target="_blank">更新日志</a></Row>
                <Row><a href="https://github.com/chengllNice/monkey-view/issues" target="_blank">反馈建议</a></Row>
                <Row><a href="https://github.com/" target="_blank">加入我们</a></Row>
            </Col>
        </Row>
    </div>
</template>

<script>
    export default {
        name: 'DocFooter'
    }
</script>
